.about {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.title {
  font-size: 4rem;
  font-weight: 530;
  color: #4075ae;
  margin: 70px;
  margin-bottom: 30px;
}

.author {
  width: 100%;
  margin-right: 500px;
  font-size: 2rem;
  font-weight: 530;
  color: #e6984b;
  text-align: right;
}

.content {
  width: 100%;
  height: 100%;
  padding: 70px 200px 200px;
  font-size: 2rem;
  text-align: center;
  color: #224771;
}
